import {login, logout, getInfo} from '@/api/login'
import {getToken, setToken, removeToken} from '@/utils/auth'
import {clearPageDrafts} from '@/utils/pageDraftStorage'
import defAva from '@/assets/images/profile.jpg'


const useUserStore = defineStore(
    'user',
    {
        state: () => ({
            token: getToken(),
            id: '',
            name: '',
            avatar: '',
            nickName: '',
            email: '',
            phonenumber: '',
            company: '',
            position: '',
            category: '',
            roles: [],
            roleNames: [],
            permissions: [],
        }),
        actions: {
            // 登录
            login(userInfo) {
                const username = userInfo.username.trim()
                const password = userInfo.password
                const code = userInfo.code
                const uuid = userInfo.uuid
                return new Promise((resolve, reject) => {
                    login(username, password, code, uuid).then(res => {
                        clearPageDrafts()
                        setToken(res.token)
                        this.token = res.token
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 获取用户信息
            getInfo() {
                return new Promise((resolve, reject) => {
                    getInfo().then(res => {
                        const user = res.user
                        const avatar = (user.avatar == "" || user.avatar == null) ? defAva : user.avatar;

                        const roleDetailList = Array.isArray(user?.role) ? user.role : []
                        this.roleNames = roleDetailList
                            .map((r) => (r && (r.roleName || r.role_name)) ? String(r.roleName || r.role_name).trim() : '')
                            .filter(Boolean)

                        if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                            this.roles = res.roles
                            this.permissions = res.permissions
                        } else {
                            this.roles = ['ROLE_DEFAULT']
                        }
                        this.id = user.userId
                        this.name = user.userName
                        this.nickName = user.nickName
                        this.email = user.email
                        this.phonenumber = user.phonenumber
                        this.company = user.company
                        this.position = user.position
                        this.category = user.category || ''
                        this.avatar = avatar
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 退出系统
            logOut() {
                return new Promise((resolve, reject) => {
                    logout(this.token).then(() => {
                        this.token = ''
                        this.roles = []
                        this.roleNames = []
                        this.permissions = []
                        removeToken()
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            }
        }
    })

export default useUserStore
